<div class="ai-assistant-drawer__mobile-overlay" *transloco="let t; prefix: 'ai-assistant'">
  <nav class="ai-assistant-drawer__mobile-nav">
    @if (groups().length > 1) {
      <div class="ai-assistant-drawer__mobile-selector">
        <button
          type="button"
          class="ai-assistant-drawer__mobile-selector-header"
          (click)="toggleGroupExpanded()"
        >
          <div class="ai-assistant-drawer__mobile-selector-value">
            <span class="ai-assistant-drawer__mobile-selector-name">{{
              selectedGroup()?.group_name
            }}</span>
            <span class="ai-assistant-drawer__mobile-selector-label">{{
              t('mobile-change-group')
            }}</span>
          </div>
          <mat-icon
            class="ai-assistant-drawer__mobile-selector-chevron"
            [class.ai-assistant-drawer__mobile-selector-chevron--open]="groupExpanded()"
            >expand_more</mat-icon
          >
        </button>
        @if (groupExpanded()) {
          <div class="ai-assistant-drawer__mobile-selector-list">
            @for (group of groups(); track group.group_id) {
              <button
                type="button"
                class="ai-assistant-drawer__mobile-selector-item"
                [class.ai-assistant-drawer__mobile-selector-item--active]="
                  selectedGroup()?.group_id === group.group_id
                "
                (click)="onGroupSelected(group)"
              >
                <span>{{ group.group_name }}</span>
                @if (selectedGroup()?.group_id === group.group_id) {
                  <mat-icon class="ai-assistant-drawer__mobile-selector-check"
                    >check_circle</mat-icon
                  >
                }
              </button>
            }
          </div>
        }
      </div>
    }

    <div class="ai-assistant-drawer__mobile-selector">
      <button
        type="button"
        class="ai-assistant-drawer__mobile-selector-header"
        (click)="toggleProjectExpanded()"
        [disabled]="projectsLoading()"
      >
        <div class="ai-assistant-drawer__mobile-selector-value">
          <span class="ai-assistant-drawer__mobile-selector-name">{{
            selectedProject()?.name || t('mobile-select-project')
          }}</span>
          <span class="ai-assistant-drawer__mobile-selector-label">{{
            t('mobile-change-project')
          }}</span>
        </div>
        <mat-icon
          class="ai-assistant-drawer__mobile-selector-chevron"
          [class.ai-assistant-drawer__mobile-selector-chevron--open]="projectExpanded()"
          >expand_more</mat-icon
        >
      </button>
      @if (projectExpanded()) {
        <div class="ai-assistant-drawer__mobile-selector-list">
          @if (projectsLoading()) {
            <div class="ai-assistant-drawer__mobile-selector-loading">
              <span>{{ t('loading-suggestions') }}</span>
            </div>
          } @else if (projects().length === 0) {
            <div class="ai-assistant-drawer__mobile-selector-empty">
              <span>{{ t('mobile-no-projects') }}</span>
            </div>
          } @else {
            @for (project of projects(); track project.id) {
              <button
                type="button"
                class="ai-assistant-drawer__mobile-selector-item"
                [class.ai-assistant-drawer__mobile-selector-item--active]="
                  selectedProject()?.id === project.id
                "
                (click)="onProjectSelected(project)"
              >
                <span>{{ project.name }}</span>
                @if (selectedProject()?.id === project.id) {
                  <mat-icon class="ai-assistant-drawer__mobile-selector-check"
                    >check_circle</mat-icon
                  >
                }
              </button>
            }
          }
        </div>
      }
    </div>

    <div class="ai-assistant-drawer__mobile-nav-divider"></div>

    <button
      type="button"
      class="ai-assistant-drawer__mobile-nav-item ai-assistant-drawer__mobile-nav-item--danger"
      (click)="onLogout()"
    >
      <mat-icon>logout</mat-icon>
      <span>{{ t('mobile-logout') }}</span>
    </button>
  </nav>
</div>
